/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Type_LandInputs */

const cs_public_site_demand_type_land = /** @type {(inputs: Public_Site_Demand_Type_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozemek`)
};

const en_public_site_demand_type_land = /** @type {(inputs: Public_Site_Demand_Type_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Land" |
*
* @param {Public_Site_Demand_Type_LandInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_type_land = /** @type {((inputs?: Public_Site_Demand_Type_LandInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Type_LandInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_type_land(inputs)
	return cs_public_site_demand_type_land(inputs)
});